import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logoutUser } from "../redux/actions/authActions";
import {
  updateLogoRequest,
  getAdminProfileRequest,
} from "../redux/actions/profileActions";
import { AlmataMainLogo } from "../../assets/image";
import {
  MdDashboard,
  MdFolder,
  MdPeople,
  MdAccessTime,
  MdBarChart,
  MdSettings,
  MdLogout,
  MdPerson,
  IoMdWallet,
  MdBusiness,
  MdShowChart,
  MdReceiptLong,
  MdQrCodeScanner,
  MdManageSearch,
  MdLocalOffer,
  MdEdit,
  MdExpandMore,
} from "react-icons/md";

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { sidebarCollapsed } = useSelector((state) => state.ui || {});
  const { profileData, loading2 } = useSelector((state) => state.profile || {});
  const { user } = useSelector((state) => state.auth || {});
  const fileInputRef = useRef(null);
  const [partnersOpen, setPartnersOpen] = useState(false);

  useEffect(() => {
    if (user?.id && !profileData) {
      dispatch(getAdminProfileRequest(user.id));
    }
  }, [dispatch, user?.id ,profileData]);

  const handleLogoEdit = () => {
    fileInputRef.current?.click();
  };

  const handleLogoUpload = (e) => {
    const file = e.target.files[0];
    if (!file || !user?.id) return;

    const reader = new FileReader();
    reader.onload = () => {
      const logoData = {
        logo: reader.result,
        fileName: file.name,
        fileType: file.type,
        userId: user.id,
      };
      dispatch(updateLogoRequest(logoData));
    };
    reader.readAsDataURL(file);
  };

  const menuItems = [
    { path: "/", icon: MdDashboard, label: "Dashboard" },
    { path: "/revenue", icon: MdShowChart, label: "Revenue" },
    { path: "/transactions", icon: MdReceiptLong, label: "Transaction" },
    { path: "/OEMScan", icon: MdQrCodeScanner, label: "OEM Scan" },
    { path: "/scan", icon: MdManageSearch, label: "My Scan" },
    { path: "/all-coupons", icon: MdLocalOffer, label: "Coupons" },
  ];

  const partnerItems = [
    { path: "/almata-partners", icon: MdPeople, label: "Almata Partners" },
    { path: "/itsales-Partner", icon: MdPerson, label: "IT Sales Partners" },
    { path: "/oem-partners", icon: MdBusiness, label: "OEM Partners" },
  ];

  // Check if current path is partner-related (including nested routes)
  const isPartnerRoute = () => {
    const partnerPaths = [
      "/almata-partners", "/itsales-Partner", "/oem-partners",
      "/itoemdetails", "/it-end-user-of-oem","/itsales-split-view",
      "/almataOemPartner", "/almataEndUserOfOem","/almata-oem-end-users"
    ];
    return partnerPaths.includes(location.pathname);
  };

  // Keep partners dropdown open for nested routes
  useEffect(() => {
    if (isPartnerRoute()) {
      setPartnersOpen(true);
    }
  }, [location.pathname]);

  return (
    <div
      className={`sidebar ${
        location.pathname === "/cyberRiskReport" &&
        "/cyberRiskReport/verify-mail/:token"
          ? "d-none"
          : ""
      } ${sidebarCollapsed ? "collapsed" : ""}`}
    >
      <div className="sidebar-header">
        <div
          className="logo"
          // style={{ position: "relative", display: "inline-block" }}
        >
          {loading2 && !profileData ? (
            <div
              style={{
                width: "20px",
                height: "20px",
                border: "3px solid #f3f3f3",
                borderTop: "3px solid #667eea",
                borderRadius: "50%",
                animation: "spin 1s linear infinite",
                margin: "0 auto",
              }}
            ></div>
          ) : (
            <div className="logo-container">
              <img
                src={profileData?.logo || AlmataMainLogo}
                alt="Cyber Risk Report Logo"
                className="sidebar-logo"
                onClick={() => navigate("/")}
                style={{ cursor: "pointer" }}
              />
              {!sidebarCollapsed && (
                <button
                  className="logo-edit-btn"
                  title="Change Logo"
                  onClick={handleLogoEdit}
                >
                  <MdEdit />
                </button>
              )}
            </div>
          )}
          <input
            type="file"
            ref={fileInputRef}
            onChange={handleLogoUpload}
            accept="image/*"
            style={{ display: "none" }}
          />
        </div>
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
            .logo-container {
              position: relative;
              display: inline-block;
            }
            .logo-edit-btn {
              position: absolute;
              right: -5px;
              top:0px;
              width: 25px;
              height: 25px;
              border-radius: 50%;
              background: white;
              border: 1px solid #d1d5db;
              display: flex;
              align-items: center;
              justify-content: center;
              cursor: pointer;
              font-size: 13px;
              color: #6b7280;
              opacity: 0;
              transition: opacity 0.2s ease;
            }
            .logo-container:hover .logo-edit-btn {
              opacity: 1;
            }
            .logo-edit-btn:hover {
              background: #f9fafb;
              color: #374151;
            }
            .partners-dropdown-wrapper {
              position: relative;
            }
            .partners-dropdown-toggle {
              cursor: pointer;
              display: flex;
              align-items: center;
              justify-content: space-between;
            }
            .partners-dropdown-arrow {
              transition: transform 0.2s ease;
              margin-left: auto;
              font-size: 1rem;
              opacity: 0.7;
            }
            .partners-dropdown-toggle:hover .partners-dropdown-arrow {
              opacity: 1;
            }
            .partners-dropdown-arrow.partners-open {
              transform: rotate(180deg);
            }
            .partners-dropdown-menu {
              background: transparent;
              padding: 0;
              margin: 0;
            }
            .partners-dropdown-item {
              padding: 10px 10px 10px 2.5rem !important;
              margin: 0.25rem 0.75rem !important;
              border-radius: 12px !important;
              font-size: 0.95rem !important;
              font-weight: 500 !important;
              color: rgba(255, 255, 255, 0.8) !important;
              text-decoration: none !important;
              transition: all 0.3s ease !important;
              display: flex !important;
              align-items: center !important;
              gap: 1rem !important;
            }
            .partners-dropdown-item:hover {
              background: rgba(255, 255, 255, 0.15) !important;
              color: white !important;
              transform: translateX(4px) !important;
            }
            .partners-dropdown-item.active {
              background: rgba(255, 255, 255, 0.25) !important;
              color: white !important;
              box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
            }
            .partners-dropdown-item .nav-icon {
              font-size: 1.1rem !important;
              width: 20px !important;
              min-width: 20px !important;
            }
          `}
        </style>
      </div>

      <nav className="sidebar-nav">
        {/* Dashboard */}
        <Link
          to="/"
          className={`nav-item ${
            location.pathname === "/" ? "active" : ""
          }`}
          data-tooltip="Dashboard"
          onMouseEnter={(e) => {
            if (sidebarCollapsed) {
              const rect = e.currentTarget.getBoundingClientRect();
              document.documentElement.style.setProperty(
                "--tooltip-top",
                `${rect.top + rect.height / 2}px`
              );
            }
          }}
        >
          <span className="nav-icon">
            <MdDashboard />
          </span>
          <span className="nav-label">Dashboard</span>
        </Link>
        
        {/* Partners Section */}
        {sidebarCollapsed ? (
          // Show individual partner items when collapsed
          partnerItems.map((item) => {
            const IconComponent = item.icon;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`nav-item ${
                  location.pathname === item.path || 
                  (item.path === "/itsales-Partner" && (location.pathname === "/itoemdetails" || location.pathname === "/it-end-user-of-oem")) ||
                  (item.path === "/almata-partners" && (location.pathname === "/almataOemPartner" || location.pathname === "/almataEndUserOfOem"))
                  ? "active" : ""
                }`}
                data-tooltip={item.label}
                onMouseEnter={(e) => {
                  const rect = e.currentTarget.getBoundingClientRect();
                  document.documentElement.style.setProperty(
                    "--tooltip-top",
                    `${rect.top + rect.height / 2}px`
                  );
                }}
              >
                <span className="nav-icon">
                  <IconComponent />
                </span>
                <span className="nav-label">{item.label}</span>
              </Link>
            );
          })
        ) : (
          // Show dropdown when expanded
          <div className="partners-dropdown-wrapper">
            <div
              className={`nav-item partners-dropdown-toggle ${
                isPartnerRoute() ? "active" : ""
              }`}
              onClick={() => setPartnersOpen(!partnersOpen)}
              data-tooltip="Partners"
            >
              <span className="nav-icon">
                <MdPeople />
              </span>
              <span className="nav-label">Partners</span>
              <span className={`partners-dropdown-arrow ${partnersOpen ? 'partners-open' : ''}`}>
                <MdExpandMore />
              </span>
            </div>
            
            {partnersOpen && (
              <div className="partners-dropdown-menu">
                {partnerItems.map((item) => {
                  const IconComponent = item.icon;
                  return (
                    <Link
                      key={item.path}
                      to={item.path}
                      className={`nav-item partners-dropdown-item ${
                        location.pathname === item.path || 
                        (item.path === "/itsales-Partner" && (location.pathname === "/itoemdetails" || location.pathname === "/it-end-user-of-oem")) ||
                        (item.path === "/almata-partners" && (location.pathname === "/almataOemPartner" || location.pathname === "/almataEndUserOfOem"))
                        ? "active" : ""
                      }`}
                    >
                      <span className="nav-icon">
                        <IconComponent />
                      </span>
                      <span className="nav-label">{item.label}</span>
                    </Link>
                  );
                })}
              </div>
            )}
          </div>
        )}
        
        {/* Other Menu Items */}
        {menuItems.slice(1).map((item) => {
          const IconComponent = item.icon;
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-item ${
                location.pathname === item.path ? "active" : ""
              }`}
              data-tooltip={item.label}
              onMouseEnter={(e) => {
                if (sidebarCollapsed) {
                  const rect = e.currentTarget.getBoundingClientRect();
                  document.documentElement.style.setProperty(
                    "--tooltip-top",
                    `${rect.top + rect.height / 2}px`
                  );
                }
              }}
            >
              <span className="nav-icon">
                <IconComponent />
              </span>
              <span className="nav-label">{item.label}</span>
            </Link>
          );
        })}
      </nav>

      {/* <div className="sidebar-footer">
        <div className="user-info">
          <div className="user-avatar">
            <MdPerson />
          </div>
          <div className="user-details">
            <button
              className="logout-btn"
              onClick={() => {
                sessionStorage.removeItem("authToken");
                sessionStorage.removeItem("user");
                dispatch(logoutUser());
                window.location.href = "/login";
              }}
            >
              <MdLogout />
              <span>LOGOUT</span>
            </button>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default Sidebar;
